<template>
  <div>
    <InputWithCompression
      name="attachments"
      type="file"
      accept="image/x-png,image/gif,image/jpeg"
      :compression="[
        {
          compression: 0.01,
          maxHeight: 1000,
          maxWidth: 1000,
          toBase64: true,
          mimeType: 'image/jpeg'
        },
      ]"
      :showCounter="false"
      :key="inputKey"
      @change="onFileInput"
      :numImages="previews.length"
    />
  </div>
  <div class="flex flex-wrap gap-4 mt-4">
    <div v-if="!!previews.length" v-for="(preview, index) in previews" class="relative flex gap-1 flex-col">
      <img :src="preview" class="w-[154px] h-auto rounded-[8px]" />

      <button
        class="flex justify-between px-[10px] py-2 rounded-[4px] text-[14px] font-bold bg-danger-10 mt-1 text-wine-red hover:bg-danger hover:text-white"
        @click.prevent="removeAt(index)"
      >
        Ta bort bild <IconTrashCan />
      </button>
    </div>
  </div>
</template>

<script>
import Draw from '@/components/ui/draw';
import Disablable from '@/components/ui/disablable';
import InputWithCompression from '@/components/ui/inputwithcompression';
import IconTrashCan from '@/components/icons/IconTrashCan';


export default {
  components: { Disablable, Draw, InputWithCompression, IconTrashCan },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputKey: 'input',
      internalValue: [],
      showLoader: true,
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.internalValue = [];
          this.$emit('update:modelValue', []);
          return;
        }

        this.internalValue = [...value]; // Create a new array to ensure reactivity
        return this.fetchPreviews();
      },
    },
  },

  computed: {
    previews() {
      if (!this.internalValue || this.internalValue.length === 0) return [];
      const previews = [];

      this.internalValue.forEach((img) => {
        //console.log("img.filename", JSON.parse(JSON.stringify(img)))
        //const uploaded = this.$store.getters.getUploadedPhotoById(img.filename);
        //console.log("uploaded", uploaded)
        if (img && img.data) previews.push(img.data);
      });

      return previews;
    },
  },

  methods: {
    onFileInput(objects) {
      if (objects?.type === 'change') return;

      this.showLoader = true; // Show loader before upload starts

      console.log("objects", objects)
      Promise.all(
        objects
          .filter((image) => image.settings.toBase64)
          .map((image) => {
            return this.$store.dispatch('uploadPhoto', image.data).then((id) => ({
              id,
              data: image.data
            }));
          })
      )
        .then((results) => {
          const newInternalValue = [...this.internalValue];
          console.log("res", results)
          results.forEach(({ id, data }) => {
            newInternalValue.push({
              filename: id,
              imageType: 'image',
              data: data
            });
          });

          console.log("newInternalValue", newInternalValue)

          this.internalValue = newInternalValue;

          // Tvingar input - file att renderas om
          this.inputKey = 'random-' + Math.random();

          // Emit both events for compatibility
          this.$emit('update:modelValue', this.internalValue);
          this.$emit('input', this.internalValue);

          // Fetch previews after uploading to update the UI
          this.fetchPreviews();
        })
        .finally(() => {
          this.showLoader = false;
        });
    },

    removeAt(index) {
      // Create a new array for proper reactivity
      const newInternalValue = [...this.internalValue];
      newInternalValue.splice(index, 1);
      this.internalValue = newInternalValue;

      this.$emit('update:modelValue', this.internalValue);
      this.$emit('input', this.internalValue);
    },

    async fetchPreviews() {
      const imgs = this.internalValue || [];
      if (imgs.length === 0) return Promise.resolve();

      this.showLoader = true;
      return Promise.all(
        imgs.map((img) => {
          return this.$store.cache.dispatch('fetchUploadedPhoto', img.filename);
        }),
      ).finally(() => {
        this.showLoader = false;
        // Force component to re-render after fetching previews
        this.$forceUpdate();
      });
    },
  },

  created() {
    this.fetchPreviews();
    // För att change ska triggas och "Forsätt" ska visas
    this.$emit('update:modelValue', this.internalValue);
    this.$emit('input', this.internalValue);
  },
  mounted() {
    $('.image-uploader-wrapper').focus();
  },
};
</script>
